"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewTariff extends new_item_1.default {
    constructor(newTariff) {
        super();
        this.name = newTariff.name;
        this.currency = newTariff.currency;
        this.utilityType = newTariff.utilityType;
        this.organisationId = newTariff.organisationId;
        this.standingCharge = newTariff.standingCharge;
        this.rates = newTariff.rates;
        this.contractStart = newTariff.contractStart;
        this.contractEnd = newTariff.contractEnd;
        this.billingCycleType = newTariff.billingCycleType;
        this.billingCycleStartDay = newTariff.billingCycleStartDay;
        this.applyContractRange = newTariff.applyContractRange;
        this.applyBillingCycle = newTariff.applyBillingCycle;
        this.siteId = newTariff.siteId;
        this.siteIds = newTariff.siteIds;
        this._permission = newTariff._permission;
    }
}
exports.default = NewTariff;
//# sourceMappingURL=new-tariff.js.map